import { gsap } from "../gsap/all.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
export default {
	init() {
    // Top Graphic
    let shapes = document.querySelector('.upper-graphic')
    gsap.to(shapes, { scale: 1, opacity: 1})
    // Left Graphic
    let lg = document.querySelector('.left-graph')
    if (lg) {
      let lgtl = gsap.timeline({
        scrollTrigger: {
          trigger: lg,
          start: 'top center',
        },
      })
      lgtl.to(lg, {opacity: 1, scale: 1, duration: 1, ease: 'power4.out'})
    }
  },
  finalize() {
  },
};

function imageOrientation(src) {

  var orientation,
  img = new Image();
  img.src = src;

  var w = img.naturalWidth,
  h = img.naturalHeight,
  ratio = 1;

  if (w > h) {
      ratio = (w / h);
  } else if (w < h) {
      ratio = (h / w)
  }

  if ((ratio - 1) > 0.2) {
    orientation = 'landscape';
  } else if ((ratio - 1) < -0.2) {
    orientation = 'portrait';
  } else {
    orientation = 'square';
  }

  console.log(ratio);

  return orientation;
}

$(document).ready(function () {
  if ($('.work-gallery > div').length !== -1) {
    $('.work-gallery img').each(function(e) {
      var o = imageOrientation($(this).attr('src'));
      $(this).parent('div').addClass(o);
    });
  }
});
